import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bg from "../assets/images/bg-headers.png";
import Header from "../components/Header";
import { BankData } from "../data/BankData";
import _ from "lodash";
import { useAuth } from "../components/auth/authContext";
import useAPI from "../hooks/useAPI";
import { ReactComponent as UsersIcon } from "../assets/icons/users.svg";
import { ReactComponent as StoreIcon } from "../assets/icons/building-02.svg";
import { ReactComponent as ProfileIcon } from "../assets/icons/user-circle.svg";
import { ReactComponent as SignOutIcon } from "../assets/icons/signout.svg";
import { ReactComponent as ChevronIcon } from "../assets/icons/chevron.svg";
import { requestAuthDelete, requestAuthGet } from "../api/authInstance";
import Container from "../components/Container/Container";
import InformationSheet from "../components/Sheet/InformationSheet";
import { useTranslation } from "react-i18next";
import KartiniCopyright from "../components/KartiniCopyright";
import DompetVersion from "../components/DompetVersion";

function Settings() {
  const { userData, logout } = useAuth();
  const { t } = useTranslation();
  const [users, loading, fetchUsers, params, paramsUsers] = useAPI("/users", {
    applicationType: "WALLET",
    retailer: userData?.outlet?.retailer?.id,
    walletAdmin: false,
    limit: 10000,
  });
  const [outlets, loadingOutlet, fetchOutlet] = useAPI("/outlets", {
    retailer: userData?.outlet?.retailer?.id,
    limit: 10000,
  });

  const [roles, loadingRole, fetchRole] = useAPI("/role", {
    applicationType: "WALLET",
    limit: 10000,
  });

  const [type, setType] = useState("");
  const [data, setData] = useState({});

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("dompet_user")),
  );
  const [dataOutlet, setDataOutlet] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );

  // state input user
  const [inputUser, setInputUser] = useState({});
  const [modalUserDetails, setModalUserDetails] = useState({
    title: "Add User",
    type: "Add",
  });
  const [validationUsers, setValidationUsers] = useState({
    email: {
      validate: true,
      message: "",
    },
    phone: {
      validate: true,
      message: "",
    },
    general: {
      validate: true,
      message: "",
    },
  });

  // state input outlet
  const [inputOutlet, setInputOutlet] = useState({});
  const [inputBank, setInputBank] = useState({});
  const [modalOutletDetails, setModalOutletDetails] = useState({
    title: "Add Outlet",
    type: "Add",
  });

  const [optionsData, setOptionsData] = useState({
    outlets: [],
    banks: [],
  });
  const [isBannerShow, setIsBannerShow] = useState({
    renew_bank_data: false,
    disable_change_data: user?.user_type === "member",
  });

  // state loading
  const [buttonLoading, setButtonLoading] = useState(false);

  // modal state
  const [showModalOutlet, setShowModalOutlet] = useState(false);
  const [showDeleteConfirmationModalUser, setShowDeleteConfirmationModalUser] =
    useState(false);
  const [
    showDeleteConfirmationModalOutlet,
    setShowDeleteConfirmationModalOutlet,
  ] = useState(false);
  const [showModalUser, setShowModalUser] = useState(false);

  const navigate = useNavigate();

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  useEffect(() => {
    GetAllDataRequire();
  }, []);

  useEffect(() => {
    if (showModalUser === false) {
      setInputUser({});
      setValidationUsers({
        email: {
          validate: true,
          message: "",
        },
        phone: {
          validate: true,
          message: "",
        },
        general: {
          validate: true,
          message: "",
        },
      });
    }
  }, [showModalUser]);

  async function GetAllDataRequire() {
    // validate user only user admin or master
    if (userData?.role?.walletAdmin) {
      try {
        // GET Bank Data
        await GetDataBank();
      } catch (error) {
        console.error(error);
      }
    }
  }

  async function GetDataBank() {
    try {
      // Get data bank details
      let bank = await requestAuthGet(`/bank-account`, {
        params: { retailer: userData?.outlet?.retailer?.id },
      });
      if (bank.data.data[0]) {
        bank = bank.data.data[0];
      }
      setInputBank((prevState) => ({
        ...prevState,
        bank_account_id: bank.bank_account_id,
        bankName: bank.bankName,
        accountNumber: bank.accountNumber,
        name: bank.name,
      }));
      // SET bank options
      setOptionsData((prevState) => ({
        ...prevState,
        banks: BankData.map((value) => ({
          label: value.name,
          value: value.id,
        })),
      }));
      // set logic show banner require renew bank data
      setIsBannerShow((prevState) => ({
        ...prevState,
        renew_bank_data: _.isEmpty(
          BankData.filter((option) => option.channel_code === bank.bankName),
        ),
      }));
    } catch (error) {
      console.error(error);
    }
  }

  async function DeleteUser() {
    setButtonLoading(true);
    try {
      const response = await requestAuthDelete(`users/${data.id}`);
      if (response.data.err) {
        setValidationUsers((prevState) => ({
          ...prevState,
          general: {
            validate: false,
            message: t("profile.failedDeleteMsg"),
          },
        }));
        return;
      }
    } catch (error) {
      setValidationUsers((prevState) => ({
        ...prevState,
        general: {
          validate: false,
          message: t("profile.failedDeleteMsg"),
        },
      }));
      console.error(error);
    }

    fetchUsers();
    setButtonLoading(false);
    setShowDeleteConfirmationModalUser(false);
  }

  // OUTLET

  const settingsData = [
    {
      link: "/profile",
      name: "Profil Saya",
      icon: <ProfileIcon />,
    },
    {
      link: "/user-management",
      name: "Manajemen Pengguna",
      icon: <UsersIcon />,
    },
    {
      link: "/outlet-management",
      name: "Manajemen Toko",
      icon: <StoreIcon />,
    },
  ];

  return (
    <>
      <Header title="Pengaturan" transparent />
      <img src={bg} alt="" className="absolute top-0 -z-50 w-full" />
      <Container>
        <div className="space-y-4 px-5 pt-28 md:px-0">
          <div className="divide-y-monochrome-400 flex flex-col divide-y-2 rounded-lg border  border-monochrome-50 bg-white shadow-sm">
            {settingsData.map((data, index) => (
              <Link
                to={data.link}
                key={index}
                className="flex justify-between p-3 font-semibold"
              >
                <div className="flex items-center gap-2">
                  {data.icon} <p>{data.name}</p>
                </div>
                <ChevronIcon />
              </Link>
            ))}
            <div
              className="flex cursor-pointer justify-between p-3 font-semibold"
              onClick={() => {
                logout();
              }}
            >
              <div className="flex items-center gap-2 text-soft-red-500">
                <SignOutIcon /> <p>Keluar</p>
              </div>
              <ChevronIcon />
            </div>
          </div>
          <div>
            <KartiniCopyright />
            <DompetVersion />
          </div>
        </div>
      </Container>
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
}

export default Settings;
